.overlay {
  position: fixed;
  inset: 0;
  z-index: var(--z-overlay);
  background: var(--color-scrim);
}

.content {
  position: fixed;
  inset-inline: 0;
  bottom: 0;
  z-index: var(--z-dialog);
  display: flex;
  flex-direction: column;
  max-height: calc(100dvh - var(--safe-top) - var(--space-6));
  border-radius: var(--radius-xl) var(--radius-xl) 0 0;
  background: var(--color-surface-raised);
  box-shadow: var(--shadow-lg);
  outline: none;
}

.handle {
  flex: none;
  margin: var(--space-2) auto 0;
}

.header {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  padding: var(--space-3) var(--space-5) var(--space-2);
}

.title {
  font-size: var(--text-lg);
  font-weight: var(--weight-semibold);
  line-height: var(--leading-snug);
}

.description {
  color: var(--color-text-muted);
  font-size: var(--text-sm);
}

.body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: var(--space-2) var(--space-5) var(--space-4);
}

.body:last-child {
  padding-bottom: calc(var(--space-5) + var(--safe-bottom));
}

.footer {
  display: flex;
  flex-direction: column-reverse;
  gap: var(--space-2);
  padding: var(--space-3) var(--space-5) calc(var(--space-4) + var(--safe-bottom));
  border-top: var(--border-width) solid var(--color-border);
}

.footer > * {
  width: 100%;
}
